@layer module {
.filter-bar__row {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
    }

.filter-bar__end {
            display: flex;
            align-items: center;
            margin-left: auto;
    }

.filter-pill {
            display: flex;
            align-items: center;
            min-width: 0;
            border: 1px solid;
    }

.filter-pill__label {
            display: inline-flex;
            flex-shrink: 0;
            align-items: center;
            white-space: nowrap;
            cursor: pointer;
    }

.filter-pill__input {
            flex-grow: 1;
            min-width: 0;
            width: 100%;
            border: none;
            outline: none;
    }
} // layer module










@layer app {
.filter-bar__row {
            gap: $size-8;
    }

.filter-bar__end {
            gap: $size-8;
    }

.filter-pill {
            gap: $size-8;
            height: $size-36;
            padding: 0 $size-12;
            border-radius: $size-18;
    }

.filter-pill__label {
            gap: $size-6;
    }

.filter-pill__input {
            padding: 0;
    }

.filter-pill__input {
            background: transparent;
    }

.filter-pill {
            background: var(--bg-surface);
            border-color: var(--border-default);
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            transition: background-color 0.25s ease, border-color 0.25s ease;
    }

.filter-pill--search {
            background: var(--page-canvas);
    }

.filter-pill:focus-within {
            border-color: var(--border-strong);
    }

.filter-pill.active {
            background: var(--color-brand-wash);
            border-color: var(--color-brand-soft);
    }

.filter-pill__label {
            color: var(--text-secondary);
    }

.filter-pill__input {
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

.filter-pill__input::placeholder {
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

.filter-pill__input[type='search']::placeholder {
            color: var(--text-secondary);
            font-weight: 400;
    }
} // layer app










@layer context {
:global(.filter-amount) .filter-pill__input {
            flex-grow: 0;
            field-sizing: content;
            width: auto;
            max-width: $size-140;
    }

.filter-pill:global(.users-search-wrapper),
.filter-pill:global(.payment-methods-search) {
            width: $size-300;
            max-width: 100%;
    }

.filter-pill:global(.filter-dates) {
            flex-wrap: wrap;
            row-gap: 0;
            height: auto;
            min-height: $size-36;
    }

      @media (max-width: 640px) {
                :global(.filter-text-row) .filter-pill {
                        flex: 1 1 100%;
                    }
          }
} // layer context
